import { render } from "./HomeObligation.vue?vue&type=template&id=7d323f6c"
import script from "./HomeObligation.vue?vue&type=script&lang=js"
export * from "./HomeObligation.vue?vue&type=script&lang=js"

import "./HomeObligation.vue?vue&type=style&index=0&id=7d323f6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__